module.exports = __webpack_public_path__ + "Mark-Simonson-Proxima-Nova-Alt-Bold-webfont.d728a3dba7deb0990ca1.ttf";


//////////////////
// WEBPACK FOOTER
// /builds/applied-technologies/apt-lab/digitalbank-frontend-projects/digitalbank-web/src/styles/fonts/ProximaNova/Mark-Simonson-Proxima-Nova-Alt-Bold-webfont.ttf
// module id = ../../../../../src/styles/fonts/ProximaNova/Mark-Simonson-Proxima-Nova-Alt-Bold-webfont.ttf
// module chunks = main styles